/* eslint-disable array-bracket-newline */
/**
 * Selectable list of enabled wallet chains
 */
import { useParams } from 'react-router-dom';

import Text from '../../atoms/Text';
import Image from '../../atoms/Image';

import { IMobileFilterProps } from '../SearchTable/SearchTable';
import { networksWithWalletData } from '../NetworkSelector/core';

import checkmark from '../../assets/images/check.svg';

import './styles.scss';

const MobileWalletsFilter = ({ setFilterValue }: IMobileFilterProps) => {
  const params = useParams();

  const chain = params.chain;

  const onOptionClick = (item: string) => {
    if (chain !== item) {
      setFilterValue!(item);
    }
  };

  return (
    <>
      {networksWithWalletData.map((item) => {
        const isActive = chain === item.getSlug();
        return (
          <div
            className={`chain_exchange_option${
              isActive ? ' chain_exchange_option--active' : ''
            }`}
            key={item.chain}
            onClick={() => onOptionClick(item.getSymbol())}
          >
            <div className='chain_exchange_option__title'>
              {isActive && (
                <div className='chain_exchange_option__title__checkmark'>
                  <Image size='m' src={checkmark} />
                </div>
              )}
              <Text size={14} className='text--weight-500'>
                {item.getTitle()}
              </Text>
            </div>
            <div className='chain_exchange_option__icon'>
              <Image
                src={item.getImage()}
                size='m'
                className={`network_selector--${item.chain}`}
              />
            </div>
          </div>
        );
      })}
    </>
  );
};

export default MobileWalletsFilter;
